import { render, staticRenderFns } from "./newsAndUpdates.vue?vue&type=template&id=deb31ae8&scoped=true"
import script from "./newsAndUpdates.vue?vue&type=script&lang=js"
export * from "./newsAndUpdates.vue?vue&type=script&lang=js"
import style0 from "./newsAndUpdates.vue?vue&type=style&index=0&id=deb31ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb31ae8",
  null
  
)

export default component.exports